import "@fontsource/poppins";
import { createTheme, Theme } from "@mui/material/styles";
import { customPalette } from "./mui-styles/mui-palette-style";
import {
  CustomButtonOwnProps,
  CustomDialog,
  CustomDrawer,
  CustomPalette,
  CustomPaletteOptions,
  CustomSwitcher,
} from "./mui-types";
import { typographyStyle } from "./mui-styles/mui-typography-style";
import { buttonVariants } from "./mui-variants/mui-button-variants";
declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    main_primary: true;
    main_secondary: true;
    main_third: true;
    column: true;
    textOnly: true;
  }
  interface ButtonOwnProps extends CustomButtonOwnProps {}
}

declare module "@mui/material/styles" {
  interface Palette extends CustomPalette {}
  interface PaletteOptions extends CustomPaletteOptions {}

  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    xxl: true;
  }
}

declare module "@mui/material/Dialog" {
  interface DialogProps extends CustomDialog {}
}

declare module "@mui/material/Drawer" {
  interface DrawerProps extends CustomDrawer {}
}

declare module "@mui/material/Switch" {
  interface SwitchProps extends CustomSwitcher {}
}

declare module "@mui/material/Button" {
  interface DialogPropsVariantOverrides {
    accept: true;
  }
}

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 380,
      sm: 750,
      md: 1000,
      lg: 1290,
      xl: 2000,
      xxl: 3000,
    },
  },
  palette: customPalette,
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({
          theme,
          ownerState,
        }: {
          theme: Theme;
          ownerState: CustomButtonOwnProps;
        }) => ({
          variants: buttonVariants({ palette: theme.palette, ownerState }),
        }),
      },
    },
  },
});

theme.typography = {
  ...theme.typography,
  fontFamily: "Poppins",
  ...typographyStyle(theme),
};
